import { initializeScheduleItemLinks } from '../schedule_link.js'

document.addEventListener('DOMContentLoaded', () => {
  initializeScheduleItemLinks();
});
